import './App.css';
import { Routes, Route } from 'react-router-dom';

import Home from "./components/Home/Home";
import Contact from './components/Contact/Contact';
import About from './components/About/About';
import Maria from './components/Maria/Maria';
import Montessori from './components/Montessori/Montessori';

// Blogs
import BlogsList from './components/Blogs/BlogsList';
import BlogDetail from './components/Blogs/BlogDetail';

// Admin
import Login from './components/Admin/Login';
import Dashboard from './components/Admin/Dashboard';
import Students from './components/Admin/Students';

// Programs
import ToddlerProgram from './components/Programs/ToddlerProgram';
import PrimaryProgram from './components/Programs/PrimaryProgram';
import ElementaryProgram from './components/Programs/ElementaryProgram';
// Gallery
import Gallery from './components/Gallery/Gallery';
import GalleryDetail from './components/Gallery/GalleryDetail';

// Admin Gallery
import AdminGallery from './components/Admin/AdminGallery';
import AdminGalleryFolder from './components/Admin/AdminGalleryFolder';


function App() {
  return (
    < >
      <Routes>

        {/* Home page */}
        <Route exact path="/" element={<Home />} />
        <Route exact path="/contact" element={<Contact />} />
        <Route exact path="/about-us" element={<About />} />
        <Route exact path="/Maria-Montessori" element={<Maria />} />
        <Route exact path="/montessori" element={<Montessori />} />

        {/* Blogs */}
        <Route exact path="/blogs" element={<BlogsList />} />
        <Route exact path="/blogs/:slug" element={<BlogDetail />} />

        {/* Admin Dashboard */}
        <Route exact path="/admin/anubhava-montessori/qwerzxcv6909" element={<Dashboard />} />
        <Route exact path="/admin/anubhava-montessori/qwerzxcv6909/login" element={<Login />} />
        <Route exact path="/admin/anubhava-montessori/qwerzxcv6909/blogs" element={<Dashboard />} />
        <Route exact path="/admin/anubhava-montessori/qwerzxcv6909/students" element={<Students />} />

        {/* Programs */}
        <Route exact path="/programs/toddler-program" element={<ToddlerProgram />} />
        <Route exact path="/programs/primary-program" element={<PrimaryProgram />} />
        <Route exact path="/programs/elementary-program" element={<ElementaryProgram />} />
        <Route exact path="/gallery" element={<Gallery />} />
        <Route exact path="/gallery/:folderId" element={<GalleryDetail />} />
        
        {/* Admin Gallery */}
        <Route exact path="/admin/anubhava-montessori/qwerzxcv6909/gallery" element={<AdminGallery />} />
        <Route exact path="/admin/anubhava-montessori/qwerzxcv6909/gallery/:folderId" element={<AdminGalleryFolder />} />


        {/* Default Page */}
        <Route path="*" element={<Home />} />

      </Routes>
    </>
  );
}

export default App;